export default __webpack_public_path__ + "static/media/amyLu.ef062b00.png";